// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"46":"6dcf13805d2b0801","618":"64ff81a2e79e6121","648":"988c34e534f6d503","814":"c2a57dce5b64c906","860":"01e546b664a1a1e0"}[chunkId] + ".js";
};